/**
 * @flow
 * @relayHash 4fd56c9a4db3b738896c732872f52724
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SearchResultsQueryVariables = {|
  after?: ?string,
  first?: ?number,
  q?: ?string,
  titleOnly?: ?boolean,
  authors?: ?$ReadOnlyArray<?number>,
  categories?: ?$ReadOnlyArray<?number>,
  references?: ?$ReadOnlyArray<?number>,
  sort?: ?string,
|};
export type SearchResultsQueryResponse = {|
  +search: ?{|
    +totalCount: ?number,
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string,
        +pk: ?number,
        +name: string,
        +preview: ?string,
        +hasAttachments: ?boolean,
        +bloc: {|
          +name: string
        |},
        +isHomeBloc: ?boolean,
        +category: {|
          +name: string
        |},
        +effectiveDate: ?string,
        +legacyEffectiveDate: ?string,
        +revisionDate: ?string,
        +approvalDate: ?string,
        +restricted: boolean,
      |}
    |}>,
  |}
|};
export type SearchResultsQuery = {|
  variables: SearchResultsQueryVariables,
  response: SearchResultsQueryResponse,
|};
*/


/*
query SearchResultsQuery(
  $after: String
  $first: Int
  $q: String
  $titleOnly: Boolean
  $authors: [Int]
  $categories: [Int]
  $references: [Int]
  $sort: String
) {
  search(after: $after, first: $first, q: $q, titleOnly: $titleOnly, authors: $authors, categories: $categories, references: $references, sort: $sort) {
    totalCount
    edges {
      node {
        id
        pk
        name
        preview
        hasAttachments
        bloc {
          name
          id
        }
        isHomeBloc
        category {
          name
          id
        }
        effectiveDate
        legacyEffectiveDate
        revisionDate
        approvalDate
        restricted
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "q",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "titleOnly",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "authors",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "categories",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "references",
    "type": "[Int]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sort",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "authors",
    "variableName": "authors",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "categories",
    "variableName": "categories",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first",
    "type": "Int"
  },
  {
    "kind": "Variable",
    "name": "q",
    "variableName": "q",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "references",
    "variableName": "references",
    "type": "[Int]"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort",
    "type": "String"
  },
  {
    "kind": "Variable",
    "name": "titleOnly",
    "variableName": "titleOnly",
    "type": "Boolean"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "totalCount",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "pk",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "preview",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasAttachments",
  "args": null,
  "storageKey": null
},
v8 = [
  v5
],
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isHomeBloc",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "effectiveDate",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "legacyEffectiveDate",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revisionDate",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "approvalDate",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "restricted",
  "args": null,
  "storageKey": null
},
v15 = [
  v5,
  v3
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "SearchResultsQuery",
  "id": "981523597dc3ca22e81da594f1e53c96",
  "text": null,
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SearchResultsQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "search",
        "storageKey": null,
        "args": v1,
        "concreteType": "SearchCountableConnection",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchCountableEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentType",
                "plural": false,
                "selections": [
                  v3,
                  v4,
                  v5,
                  v6,
                  v7,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "bloc",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocType",
                    "plural": false,
                    "selections": v8
                  },
                  v9,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CategoryType",
                    "plural": false,
                    "selections": v8
                  },
                  v10,
                  v11,
                  v12,
                  v13,
                  v14
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SearchResultsQuery",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "search",
        "storageKey": null,
        "args": v1,
        "concreteType": "SearchCountableConnection",
        "plural": false,
        "selections": [
          v2,
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "edges",
            "storageKey": null,
            "args": null,
            "concreteType": "SearchCountableEdge",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "node",
                "storageKey": null,
                "args": null,
                "concreteType": "DocumentType",
                "plural": false,
                "selections": [
                  v3,
                  v4,
                  v5,
                  v6,
                  v7,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "bloc",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BlocType",
                    "plural": false,
                    "selections": v15
                  },
                  v9,
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "category",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CategoryType",
                    "plural": false,
                    "selections": v15
                  },
                  v10,
                  v11,
                  v12,
                  v13,
                  v14
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
node.text = "query SearchResultsQuery(\n  $after: String\n  $first: Int\n  $q: String\n  $titleOnly: Boolean\n  $authors: [Int]\n  $categories: [Int]\n  $references: [Int]\n  $sort: String\n) {\n  search(after: $after, first: $first, q: $q, titleOnly: $titleOnly, authors: $authors, categories: $categories, references: $references, sort: $sort) {\n    totalCount\n    edges {\n      node {\n        id\n        pk\n        name\n        preview\n        hasAttachments\n        bloc {\n          name\n          id\n        }\n        isHomeBloc\n        category {\n          name\n          id\n        }\n        effectiveDate\n        legacyEffectiveDate\n        revisionDate\n        approvalDate\n        restricted\n      }\n    }\n  }\n}\n";
(node/*: any*/).hash = '7985da50d7a8fbe83cd5169d94ee2384';
module.exports = node;
